import dynamic from "next/dynamic";

export const DynamicHero073 = dynamic(() => import("./Hero073"), {
  suspense: true,
});
